import { CardGridItemRoot } from "./CardGridItemRoot";
import { CardGridItemImage } from "./CardGridItemImage";
import { CardGridItemPanel } from "./CardGridItemPanel";
import { CardGridItemSelectionOverlay } from "./CardGridItemSelectionOverlay";
import { CardGridItemUserInfo } from "./CardGridItemUserInfo";
import { CardGridItemDetails } from "./CardGridItemDetails";
import { CardGridItemRelationshipBadge } from "./CardGridItemRelationshipBadge";
import { CardGridItemPostedTime } from "./CardGridItemPostedTime";
import { CardGridItemQuantityPrice } from "./CardGridItemQuantityPrice";
import { CardGridItemFormattedDate } from "./CardGridItemFormattedDate";
import { CardGridItemPurchasePrice } from "./CardGridItemPurchasePrice";
import { CardGridItemContactActions } from "./CardGridItemContactActions";
import { CardGridItemOwnedActions } from "./CardGridItemOwnedActions";
import { CardGridItemAnyPrintingBadge } from "./CardGridItemAnyPrintingBadge";
import { CardGridItemCardAttributes } from "./CardGridItemCardAttributes";

export const CardGridItem = {
  Root: CardGridItemRoot,
  Image: CardGridItemImage,
  Panel: CardGridItemPanel,
  SelectionOverlay: CardGridItemSelectionOverlay,
  UserInfo: CardGridItemUserInfo,
  Details: CardGridItemDetails,
  RelationshipBadge: CardGridItemRelationshipBadge,
  PostedTime: CardGridItemPostedTime,
  QuantityPrice: CardGridItemQuantityPrice,
  FormattedDate: CardGridItemFormattedDate,
  PurchasePrice: CardGridItemPurchasePrice,
  ContactActions: CardGridItemContactActions,
  OwnedActions: CardGridItemOwnedActions,
  AnyPrintingBadge: CardGridItemAnyPrintingBadge,
  CardAttributes: CardGridItemCardAttributes,
} as const;
